
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAdjuntos } from "../../Redux/ghResponde";

const useGetAdjuntos = (token, id) => {

  const dispatch = useDispatch();

  const loadingAdjuntosSelector = useSelector((store) => store.ghResponde.loadingAdjuntos);
  const adjuntosSelector = useSelector((store) => store.ghResponde.adjuntos);
  const [adjuntos, setAdjuntos] = useState([]);

  useEffect(() => {
    if (token && id) {
        dispatch(fetchAdjuntos(token, id));
    }
  }, [token, id]);

  useEffect(() => {
    if (adjuntosSelector?.length > 0) {
      const newArray = adjuntosSelector.map((item) => ({
        id: item.annotationid,
        filename: item.filename,
        mimetype: item.mimetype,
        documentbody: item.documentbody
      }));

      setAdjuntos(newArray);
    }
  }, [adjuntosSelector, loadingAdjuntosSelector]);

  return { adjuntos, loadingAdjuntosSelector, setAdjuntos };
};

export default useGetAdjuntos;
